const loggedNavMenuItems = [
  { title: 'Dashboard', path: '/' },
  { title: 'My Account', path: '/accountStatus' },
]

const mobileMenuContent = [
  {
    title: 'Docs',
    content: [
      {
        title: 'Online',
        path: 'https://developer.paypal.com/docs/online/',
      },
      {
        title: 'In-Person',
        path: 'https://developer.paypal.com/docs/in-person/',
      },
      {
        title: 'Multiparty',
        path: 'https://developer.paypal.com/docs/multiparty/',
      },
      {
        title: '3rd-Party',
        path: 'https://developer.paypal.com/docs/3rd-party/',
      },
      {
        title: 'Payouts',
        path: 'https://developer.paypal.com/docs/payouts/',
      },
      {
        title: 'Disputes',
        path: 'https://developer.paypal.com/docs/disputes/',
      },
      {
        title: 'Reports',
        path: 'https://developer.paypal.com/docs/reports/',
      },
      {
        title: 'Identity',
        path: 'https://developer.paypal.com/docs/log-in-with-paypal/',
      },
      {
        title: 'Docs Archive',
        path: 'https://developer.paypal.com/docs/archive',
      },
    ],
  },
  {
    title: 'APIs & SDKs',
    content: [
      {
        title: 'REST APIs',
        path: 'https://developer.paypal.com/api/rest/',
      },
      {
        title: 'Javascript SDK',
        path: 'https://developer.paypal.com/sdk/js/',
      },
      {
        title: 'NVP/SOAP APIs',
        path: 'https://developer.paypal.com/api/nvp-soap/',
      },
      {
        title: 'Donate SDK',
        path: 'https://developer.paypal.com/sdk/donate/',
      },
      {
        title: 'Braintree GraphQL API',
        path: 'https://graphql.braintreepayments.com/',
      },
    ],
  },
  {
    title: 'Tools',
    content: [
      {
        title: 'Integration Builder',
        path: 'https://developer.paypal.com/integration-builder/',
      },
      {
        title: 'Sandbox Testing Guide',
        path: 'https://developer.paypal.com/tools/sandbox/',
      },
      {
        title: 'API Executor',
        path: 'https://www.paypal.com/apex/home',
      },
      {
        title: 'Demo Portal',
        path: 'https://demo.paypal.com/us/demo/home',
      },
      {
        title: 'API Status',
        path: 'https://www.paypal-status.com/api/production',
      },
      {
        title: 'Webhooks',
        path: 'https://developer.paypal.com/api/rest/webhooks/',
      },
      {
        title: 'Integration Builder',
        path: 'https://developer.paypal.com/integration-builder/',
      },
    ],
  },
  { title: 'Video Library', path: 'https://developer.paypal.com/video/home' },
  { title: 'Support', path: 'https://developer.paypal.com/docs/support' },
]

const mobileUserMenuContent = [
  { title: 'Dashboard', path: '/' },
  { title: 'My Account', path: '/accountStatus' },
]

const sidenavNavigation = [
  {
    sectionTitle: 'Dashboard',
    items: [
      {
        title: 'Apps & Credentials',
        path: '/applications/ENVIRONMENT',
      },
      {
        title: 'Home',
        path: '/',
      },
    ],
  },

  {
    sectionTitle: 'Testing Tools',
    items: [
      {
        title: 'Sandbox Accounts',
        path: '/accounts',
      },
      {
        title: 'Sandbox Notifications',
        path: '/notifications',
      },
      {
        title: 'Webhook Simulator',
        path: '/webhooksSimulator',
      },
    ],
  },
  {
    sectionTitle: 'Event Logs',
    items: [
      {
        title: 'API Calls',
        path: '/dashboard/ENVIRONMENT',
      },
      {
        title: 'Webhook Events',
        path: '/webhooks/ENVIRONMENT',
      },
      {
        title: 'Error Logs',
        path: '/errors/ENVIRONMENT',
      },
      {
        title: 'Transactions',
        path: '/transactions/ENVIRONMENT',
      },
    ],
  },
]
const mainButtonLinks = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'Apps & Credentials',
    path: '/applications/ENVIRONMENT',
  },
  {
    title: 'Testing Tools',
    menuItems: [
      {
        title: 'Sandbox Accounts',
        path: '/accounts',
        parentTitle: 'Testing Tools',
      },
      {
        title: 'Sandbox Notifications',
        path: '/notifications',
        parentTitle: 'Testing Tools',
      },
      {
        title: 'Webhook Simulator',
        path: '/webhooksSimulator',
        parentTitle: 'Testing Tools',
      },
    ],
  },
  {
    title: 'Event Logs',
    menuItems: [
      {
        title: 'API Calls',
        path: '/dashboard/ENVIRONMENT',
        parentTitle: 'Event Logs',
      },
      {
        title: 'Webhook Events',
        path: '/webhooks/ENVIRONMENT',
        parentTitle: 'Event Logs',
      },
      {
        title: 'Error Logs',
        path: '/errors/ENVIRONMENT',
        parentTitle: 'Event Logs',
      },
      {
        title: 'Transactions',
        path: '/transactions/ENVIRONMENT',
        parentTitle: 'Event Logs',
      },
    ],
  },
]

const mainNavigationBlue = [
  {
    title: 'Docs',
    menuItems: [
      {
        title: 'Online',
        path: 'https://developer.paypal.com/docs/online/',
      },
      {
        title: 'In-Person',
        path: 'https://developer.paypal.com/docs/in-person/',
      },
      {
        title: 'Multiparty',
        path: 'https://developer.paypal.com/docs/multiparty/',
      },
      {
        title: '3rd-Party',
        path: 'https://developer.paypal.com/docs/3rd-party/',
      },
      {
        title: 'Payouts',
        path: 'https://developer.paypal.com/docs/payouts/',
      },
      {
        title: 'Disputes',
        path: 'https://developer.paypal.com/docs/disputes/',
      },
      {
        title: 'Reports',
        path: 'https://developer.paypal.com/docs/reports/',
      },
      {
        title: 'Identity',
        path: 'https://developer.paypal.com/docs/log-in-with-paypal/',
      },
      {
        title: 'Docs Archive',
        path: 'https://developer.paypal.com/docs/archive',
      },
    ],
  },
  {
    title: 'APIs & SDKs',
    menuItems: [
      {
        title: 'REST APIs',
        path: 'https://developer.paypal.com/api/rest/',
      },
      {
        title: 'Javascript SDK',
        path: 'https://developer.paypal.com/sdk/js/',
      },
      {
        title: 'NVP/SOAP APIs',
        path: 'https://developer.paypal.com/api/nvp-soap/',
      },
      {
        title: 'Donate SDK',
        path: 'https://developer.paypal.com/sdk/donate/',
      },
      {
        title: 'Braintree GraphQL API',
        path: 'https://graphql.braintreepayments.com/',
      },
    ],
  },
  {
    title: 'Tools',
    menuItems: [
      {
        title: 'Sandbox Testing Guide',
        path: 'https://developer.paypal.com//tools/sandbox/',
      },
      {
        title: 'API Executor',
        path: 'https://www.paypal.com/apex/home',
      },
      {
        title: 'Demo Portal',
        path: 'https://demo.paypal.com/us/demo/home',
      },
      {
        title: 'Credit Card Generator',
        path:
          'https://developer.paypal.com/api/rest/sandbox/card-testing/#link-creditcardgeneratorfortesting',
      },
      {
        title: 'API Status',
        path: 'https://www.paypal-status.com/api/production',
      },
      {
        title: 'Webhooks',
        path: 'https://developer.paypal.com/api/rest/webhooks/',
      },
      {
        title: 'Integration Builder',
        path: 'https://developer.paypal.com/integration-builder/',
      },
      {
        title: 'Negative Testing',
        path: 'https://developer.paypal.com/tools/sandbox/negative-testing/',
      },
    ],
  },
  {
    title: 'Video Library',
    path: 'https://developer.paypal.com/video/home',
  },
  {
    title: 'Help',
    path: 'https://www.paypal.com/smarthelp/home',
  },
  {
    title: 'Business Dashboard',
    path: 'https://www.paypal.com/mep/dashboard',
  },
]

export {
  loggedNavMenuItems,
  mobileMenuContent,
  mobileUserMenuContent,
  sidenavNavigation,
  mainButtonLinks,
  mainNavigationBlue,
}
